import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

export default function ErrorTestingPage() {
  const [shouldThrow, setShouldThrow] = useState(false);

  useEffect(() => {
    if (shouldThrow) {
      throw new Error('Test error');
    }
  }, [shouldThrow]);

  return (
    <Stack sx={{ mt: 2 }}>
      <Button
        onClick={() => setShouldThrow(true)}
        variant="contained"
        sx={{ width: 'fit-content' }}
      >
        Throw Error
      </Button>
    </Stack>
  );
}
